import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useState } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = [
    {
        accessorKey: "name",
        header: ({ column }) => <DatatableSortButton column={column}>Namn</DatatableSortButton>,
        cell: info => {
            const bunny = info.row.original;
            return <Link to={`/bunny/${bunny.id}`} className='text-blue-600 font-medium hover:underline'>{bunny.name}</Link>
        }
    },
    {
        accessorKey: "registration_number",
        header: ({ column }) => <DatatableSortButton column={column}>Reg.nr</DatatableSortButton>,
    },
    {
        accessorKey: "gender",
        header: ({ column }) => <DatatableSortButton column={column}>Kön</DatatableSortButton>,
        cell: info => {
            const bunny = info.row.original;
            if (bunny.gender === "male") return "Hane";
            if (bunny.gender === "female") return "Hona";
            return bunny.gender; // fallback in case there are other values
        }
    },
    {
        accessorKey: "color",
        header: ({ column }) => <DatatableSortButton column={column}>Färg</DatatableSortButton>,
    },
];

export function LittersBunnyDatatable({ bunnies, isLoading }) {
    const [sorting, setSorting] = useState([{ id: 'name', desc: true }]);
    const [columnFilters, setColumnFilters] = useState([]);

    const table = useReactTable({
        data: bunnies?.length > 0 ? bunnies : [], 
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return (
        <>
            <DataTable table={table} isLoading={isLoading} columns={columns} />
        </>
    );
}